import config from './config';
import { persistAccountLanguage, validLanguage } from './languagePreference';
import { saveRegistrationConsent } from '../legal/registration';
import { getLocalStorage, installSession } from './func';
import { appLocalStorage } from './storage';
import changeLanguageInOrder from './changeLanguageInOrder';
import { claimGuestAuth, safeAuthReturn } from '../guestTrial/store';
import { requestAccountOnboarding } from '../onboarding/state';

export function signInLanguage(value) {
  const language = typeof value === 'string' ? value.toLowerCase().split(/[-_]/)[0] : '';
  return language && (language === 'en' || config.languages.includes(language)) ? language : 'en';
}

export default async function finishSignIn(data, { i18n, navigate, isCurrent, registration, signal }) {
  if (data?.status_only === true) {
    if (isCurrent() && !signal?.aborted) navigate('/account-deletion', { replace: true, state: { verifiedDeletion: data.deletion || null, statusOnly: true } });
    return data;
  }
  if (!data?.user || typeof data.user !== 'object' || Array.isArray(data.user)
    || !Number.isSafeInteger(data.user.id) || data.user.id <= 0
    || typeof data.token !== 'string' || !data.token.trim()) {
    throw new Error(data?.message || 'Sign-in failed');
  }

  const startingToken = getLocalStorage(config.token);
  const current = () => isCurrent() && !signal?.aborted && getLocalStorage(config.token) === startingToken;
  if (!current()) return undefined;
  await saveRegistrationConsent(data.token, registration, { signal });
  if (!current()) return undefined;

  // A feed request must start with its final viewer/language context.
  const preferred = data.is_new_user === true && validLanguage(registration?.language) ? registration.language : null;
  if (preferred && preferred !== data.user.lng_code) {
    await persistAccountLanguage(data.token, data.user.id, preferred, signal);
    if (!current()) return undefined;
    data = { ...data, user: { ...data.user, lng_code: preferred } };
  }
  const language = signInLanguage(data.user.lng_code);
  await changeLanguageInOrder(i18n, language, current);
  if (!current()) return undefined;

  installSession(data.token, data.user);
  const from = safeAuthReturn(new URLSearchParams(window.location.search).get('from') || getLocalStorage('login_from') || '/');
  claimGuestAuth(from, data.user.id);
  try { appLocalStorage.removeItem('login_from'); } catch { /* The session is installed; navigation can continue. */ }
  if (data.is_new_user === true && requestAccountOnboarding(data.user.id, from)) {
    navigate(language === 'en' ? '/' : `/${language}/`, { replace: true,
      state: { onboardingAccount: String(data.user.id) } });
  } else navigate(from);
  return data;
}
